module.exports = function () { /* empty */ };
